module.exports = __webpack_public_path__ + "static/media/Ioannis_Evgeniou.1ba084cf.png";